import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MoveDocumentFolderComponent } from './move-document-folder.component';

@NgModule({
  declarations: [MoveDocumentFolderComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [MoveDocumentFolderComponent],
  entryComponents: [MoveDocumentFolderComponent]
})
export class MoveDocumentFolderModule { }
